export default __webpack_public_path__ + "static/bBlock-75506be8a35291604e6ebd7d7c4f3f76.svg";